<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del banco</label>
      <select id="banco_id" :value="loadData.banco_id"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idBancoNew)=>$emit('updateValues', {'banco_id': customUpdateValueData('banco_id', idBancoNew.target.value)})">
        <option value="" selected>Seleccione un banco...</option>
        <option v-for="(banco, index) of collectionBancos" :key="'B'+index" :value="banco.id">{{
            banco.nombre_banco
          }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="cuenta_bancaria" class="block text-sm font-medium text-gray-700">Cuenta bancaria</label>
      <input type="text" id="cuenta_bancaria" :value="loadData.cuenta_bancaria"
             @change="(cuentaBancariaNew)=>$emit('updateValues', {'cuenta_bancaria': customUpdateValueData('cuenta_bancaria', cuentaBancariaNew.target.value)})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre_cuenta" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="nombre_cuenta" :value="loadData.nombre_cuenta"
             @change="(cuentaBancariaNew)=>$emit('updateValues', {'nombre_cuenta': customUpdateValueData('nombre_cuenta', cuentaBancariaNew.target.value)})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="tipo_cuenta" class="block text-sm font-medium text-gray-700">Tipo de cuenta</label>
      <select id="tipo_cuenta" :value="loadData.tipo_cuenta"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(tipoCuentaNew)=>$emit('updateValues', {'tipo_cuenta': customUpdateValueData('tipo_cuenta', tipoCuentaNew.target.value)})">
        <option value="ahorros">Ahorros</option>
        <option value="corriente">Corriente</option>
        <option value="nomina">Nómina</option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="manejo_cuenta" class="block text-sm font-medium text-gray-700">Condiciones de manejo</label>
      <input type="text" id="manejo_cuenta" :value="loadData.manejo_cuenta"
             @change="(manejoCuentaNew)=>$emit('updateValues', {'manejo_cuenta': customUpdateValueData('manejo_cuenta', manejoCuentaNew.target.value)})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-3 sm:col-span-3 lg:col-span-2 flex items-center justify-center space-x-2">
      <input type="checkbox" id="check" v-model="checked" @change="()=> $emit('updateValues', {'checked' : checked})">
      <label for="check"> ¿Cuenta Bancaria para Embargo?</label>
    </div>
    <div v-if="checked" class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_macro_fuente" class="block text-sm font-medium text-gray-700">Fuente Macro</label>
      <select id="id_macro_fuente" :value="loadData.id_macro_fuente ? loadData.id_macro_fuente : selectedFuente"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idMacroFuenteNew)=> $emit('updateValues', {'id_macro_fuente': customUpdateValueData('id_macro_fuente', idMacroFuenteNew.target.value)})">
        <option value="" selected>Seleccione una Fuente Macro...</option>
        <option v-for="(fuentes, index) of collectionMacroFuentes" :key="'B'+index" :value="fuentes.id">{{
            fuentes.nombre
          }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'CuentasBancariasCrearActualizarComponent',
  props: ['view','loadData', 'collectionBancos', 'selectedData', 'collectionMacroFuentes', 'customUpdateValueData'],
  emits: ["updateValues"],

  async setup(props, {emit}) {
    const checked = ref(props.loadData.cuentasFuentesMacro.length > 0 ? true : false);
    const selectedFuente = ref(props.selectedData.cuentasFuentesMacro.length > 0 ? props.selectedData.cuentasFuentesMacro[0].id_macro_fuente : null);
    emit('updateValues', { 'checked': props.customUpdateValueData('checked', checked) })
    emit('updateValues', { 'id_macro_fuente': props.customUpdateValueData('id_macro_fuente', selectedFuente) })

    if (props.selectedData.cuentasFuentesMacro.length > 0) {
        checked.value = true;
    }
    return {
      checked,
      selectedFuente,
    }

  }
}
</script>